<div class="d-flex justify-content-end">
  <span class="dialog-close" (click)="onClose()">X</span>
</div>
<div [innerHTML]="'uploads_period_ended' | translate | safeHtml"></div>
